import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d73e9886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "dd-city" }

import { ref, Ref, watch } from "vue";
import Dropdown from "primevue/dropdown";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDropdown',
  props: {
  label: String,
  modelValue: Object,
  inputRequired: {
    type: Boolean,
    default: true,
  },
  extraMarginTop: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  inlineLabel: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: "150px",
  },
  placeholder: {
    type: String,
    default: "",
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  removeMargin: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array,
    default: () => [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



const inputValue: Ref<object> = ref({});



watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val;
  },
  { immediate: true }
);

watch(inputValue, (val) => {
  emit("update:modelValue", val);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["p-float-label", { 'mt-4 mt-lg-5': __props.extraMarginTop }])
  }, [
    _createVNode(_unref(Dropdown), {
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      disabled: __props.disabled,
      options: __props.options,
      optionLabel: "title",
      class: "wrapper-dropdown",
      placeholder: __props.placeholder,
      style: _normalizeStyle(`max-width: ${__props.width}; min-width: ${__props.width};`)
    }, null, 8, ["modelValue", "disabled", "options", "placeholder", "style"]),
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.placeholder), 1)
  ], 2))
}
}

})